import http from '@/services/http';
import { analysesStatusFilters } from '@/config';
import tableHelper from '@/services/tableHelper';

const analysesData = {
  samplesIndex(tableFilters, filterStatus, config = {}) {
    const filters = tableHelper.whereFilters(
      filterStatus,
      analysesStatusFilters
    );
    return http.request({
      method: 'get',
      url: '/samples',
      params: { filter: { ...tableFilters, where: filters } },
      ...config,
    });
  },
  samplesCount(filterStatus, config = {}) {
    const where = tableHelper.whereFilters(filterStatus, analysesStatusFilters);
    return http.request({
      method: 'get',
      url: '/samples/count',
      params: { where },
      ...config,
    });
  },
};

export default analysesData;
